exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".el-tabs__active-bar .is-top{width:84px!important;-webkit-transform:translateX(288px);transform:translateX(288px)}", ""]);
